var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `col-${_vm.span}`,
    _vm.offset ? `col-offset-${_vm.offset}` : ''
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }